import { Link, useLocation } from "react-router-dom";
import { Moon, Sun, LogOut, Settings, ShieldCheck } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { useAuth } from "@/context/AuthContext";
import { navItems } from "./navItems";
import styles from "./Topbar.module.css";

// Rotas acessíveis fora do menu principal.
const EXTRA_TITLES: Record<string, string> = {
  "/contas": "Contas e cartões",
  "/configuracoes": "Configurações",
  "/admin": "Painel admin",
  "/premium": "Premium",
};

function getInitials(name?: string) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "";
  return (first + last).toUpperCase();
}

export function Topbar() {
  const { theme, toggleTheme } = useTheme();
  const { user, logout } = useAuth();
  const location = useLocation();

  const currentPage = navItems.find((item) => (item.to === "/" ? location.pathname === "/" : location.pathname.startsWith(item.to)));
  const pageTitle = currentPage?.label ?? EXTRA_TITLES[location.pathname] ?? "ControleNext";

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <span className={styles.pageTitle}>{pageTitle}</span>
        <span className={styles.greeting}>
          {user ? (
            <>
              Olá, <span className={styles.greetingName}>{user.name.split(" ")[0]}</span>
            </>
          ) : (
            "Modo demonstração"
          )}
        </span>
      </div>
      <div className={styles.actions}>
        <button onClick={toggleTheme} className={styles.iconButton} aria-label="Alternar tema">
          {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
        </button>
        {user ? (
          <>
            {user.isAdmin && (
              <Link to="/admin" className={styles.iconButton} aria-label="Painel admin">
                <ShieldCheck size={18} />
              </Link>
            )}
            <Link to="/configuracoes" className={styles.iconButton} aria-label="Configurações">
              <Settings size={18} />
            </Link>
            <button onClick={() => logout()} className={styles.logoutButton} aria-label="Sair">
              <LogOut size={16} />
              <span className={styles.logoutLabel}>Sair</span>
            </button>
            <div className={styles.avatar}>{getInitials(user.name)}</div>
          </>
        ) : (
          <>
            <Link to="/login" className={styles.loginLink}>
              Entrar
            </Link>
            <Link to="/cadastro" className={styles.signupButton}>
              Criar conta
            </Link>
          </>
        )}
      </div>
    </header>
  );
}
